import type { FieldPath, FieldValues } from "react-hook-form";
import type { FormInputData } from "../components/BuildingBlocks/Forms/Controllers/FormFieldController";

/** Collects the names of tabs that have highlighted fields */
export function collectHighlightedTabs<T extends FieldValues>(
  formFieldData: Record<string, FormInputData<T, FieldPath<T>> | undefined>
): Array<string> {
  const tabs = new Set<string>();

  for (const field of Object.values(formFieldData)) {
    if (field?.highlight && field?.group) {
      tabs.add(field.group);
    }
  }

  return Array.from(tabs);
}
